export default "images/路径 15672.png";